import React from "react";

const Backend = () => {
    return(
        <div className="skills__content">
      <h3 className="skills__title">Backend Developer</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">MongoDB</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">Node.JS</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">Express.JS</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">Postman</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">API Rest</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>

          <div className="skills__data">
            <i className="bx bx-badge-check"></i>

            <div>
                <h3 className="skills__name">Deployments <br/>(Heroku & others)</h3>
                <span className="skills__level"><br/></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}

export default Backend;